module.exports = __webpack_public_path__ + "static/img/card4.1b89fff5.jpg";